import { createSlice } from '@reduxjs/toolkit'
import { getSecurityFacts } from './reducer'

const initialState = ['The number of cyber attacks is going UP not down']

export const securityFactsSlice = createSlice({
	name: 'securityFacts',
	initialState,
	extraReducers: {
		[getSecurityFacts.fulfilled]: (_, action) => action.payload
	}
})

export const securityFactsReducer = securityFactsSlice.reducer
